<template>
    <ErrorPage code="403" status="Forbidden" :message="message" :href-text="hrefText" :href="href"/>
</template>

<script>
  import ErrorPage from "../components/ErrorPage";

  export default {
    name: "ErrorForbidden",
    components: {ErrorPage},
    computed: {
      isUser() {
        return typeof this.$store.state.session.user.Id !== 'undefined';
      },
      message() {
        if (this.isUser) {
          return 'You may need to request access from the model owner.';
        } else {
          return 'Your membership may be insufficient.';
        }
      },
      hrefText() {
        if (this.isUser) {
          return 'Go to Gears App';
        } else {
          return 'Go to my account';
        }
      },
      href() {
        if (this.isUser) {
          return this.$urls.APP_HOME;
        } else {
          return this.$urls.USER_ACCOUNT;
        }
      },
    }
  }
</script>

<style scoped>

</style>
